import React from "react";
import { Link } from "react-router-dom";
import { FiArrowUpRight } from "react-icons/fi";
import "./AllSectorsSectors.css";
import { resolveMediaUrl } from "../../../../utils/media";

import commercialImg from "../../../../assets/images/home/hospitality/c1.jpg";
import residentialImg from "../../../../assets/images/home/hospitality/c2.jpg";
import entertainmentImg from "../../../../assets/images/home/hospitality/c3.jpg";
import hospitalityImg from "../../../../assets/images/home/hospitality/c4.png";

const fallbackSectors = [
  { title: "COMMERCIAL", slug: "commercial", image: commercialImg },
  { title: "RESIDENTIAL", slug: "residential", image: residentialImg },
  { title: "ENTERTAINMENT", slug: "entertainment", image: entertainmentImg },
  { title: "HOSPITALITY", slug: "hospitality", image: hospitalityImg },
  { title: "UNIVERSITY", slug: "education", image: residentialImg },
  { title: "HEALTHCARE", slug: "healthcare", image: commercialImg },
];

const AllSectorsSectors = ({ sectors }) => {
  const data = Array.isArray(sectors) && sectors.length
    ? sectors.map((sector, idx) => {
        const fallback = fallbackSectors[idx % fallbackSectors.length];
        return {
          title: String(sector?.title || fallback.title || "").toUpperCase(),
          slug: sector?.slug || fallback.slug,
          image: resolveMediaUrl(sector?.image || sector?.imageUrl || sector?.mediaUrl) || fallback.image,
        };
      })
    : fallbackSectors;

  return (
    <section className="allSectorsGridSection">
      <div className="allSectorsGridContainer">
        <span className="allSectorsGridTag">SECTORS</span>
        <h2>Explore our sectors</h2>

        <div className="allSectorsGrid">
          {data.map((sector) => (
            <Link
              key={sector.slug}
              to={`/sectors/${sector.slug}`}
              className="allSectorsCard"
            >
              <div className="allSectorsCardImageWrap">
                <img src={sector.image} alt={sector.title} />
              </div>

              <div className="allSectorsCardFooter">
                <h3>{sector.title}</h3>
                <FiArrowUpRight className="allSectorsCardArrow" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AllSectorsSectors;